<h1 mat-dialog-title>{{ 'Filtri disponibili' | translate }}</h1>
<div
  class="filters-contanier column"
  mat-dialog-content>
  <ng-container #mobileFilterRef></ng-container>
</div>
<div mat-dialog-actions>
  <button
    mat-raised-button
    type="button"
    (click)="closeHandler()">
    {{ 'Annulla' | translate }}
  </button>
  <button
    mat-raised-button
    color="primary"
    type="button"
    (click)="applyHandler()">
    {{ 'Applica' | translate }}
  </button>
</div>
